import { Component } from "react";

import TableNew from "../../../shared/Table";
import RefreshButton from "../../../shared/ui/Refresh.Button";

import { getFinancingIssuedColumns } from "./financingColumns";
import PayoutTableButtons from "./Table/PayoutTableButtons";

import { numberWithSpaces } from "../../../utilities/formaters";
import PropTypes from "prop-types";
import { payoutConnector } from "../../../services/financing/payouts/connector";
import { compose } from "redux";
import { mplPayoutConnector } from "../../../services/financing/mpl.financing/MPL.Payouts.connector";

class PayoutComponent extends Component {
  constructor(props) {
    super(props);

    let payoutColumns = getFinancingIssuedColumns(
      props.getFinancingPayoutInfo,
      props.registerPayout,
      this.getPayoutInfo,
      props.cancelLoan,
    );

    this.state = { payoutColumns };
  }

  getPayoutInfo = (id) => {
    return this.props.payout[id] ? this.props.payout[id] : {};
  };

  UNSAFE_componentWillMount() {
    this.props.getLoansForPayout();
    this.checkForFinancings(this.props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    // What the actual F. is that?
    this.checkForFinancings(props);
  }

  checkForFinancings(props) {
    let itemsCombined = props.loansForPayout.data;
    for (var i = 0; i < itemsCombined.length; i++) {
      itemsCombined[i].payout = this.props.payout[itemsCombined[i].Id];
      if (
        !itemsCombined[i].payout ||
        (!itemsCombined[i].payout.fetched &&
          !itemsCombined[i].payout.fetching &&
          !itemsCombined[i].payout.error)
      ) {
        props.getFinancingPayoutInfo(itemsCombined[i].Id);
      }
    }
  }

  render() {
    let itemsCombined = this.props.loansForPayout.data;
    let payoutSum = 0;
    let savelendSum = 0;
    let borrowerSum = 0;
    let assigned = 0;
    let display = false;

    for (var i = 0; i < itemsCombined.length; i++) {
      itemsCombined[i].payout = this.props.payout[itemsCombined[i].Id];
      if (itemsCombined[i].payout && itemsCombined[i].payout.fetched) {
        assigned++;
        let initFee = itemsCombined[i].payout.data.InitFee
          ? itemsCombined[i].payout.data.InitFee.Amount
          : 0;
        borrowerSum += itemsCombined[i].payout.data.PayoutAmount.Amount;
        savelendSum += initFee;
        payoutSum += itemsCombined[i].payout.data.PayoutAmount.Amount + initFee;
      }
    }

    if (assigned == itemsCombined.length) display = true;

    return (
      <div className="financing-layout body-height content-padding">
        <RefreshButton onRefreshClick={this.props.getLoansForPayout} />
        <h3>Loanstep: Loans ready for payout</h3>
        {display ? (
          <div>
            <p>
              Sum for payout: {numberWithSpaces(payoutSum)}
              <br />
            </p>
            <p>
              Sum for Savelend: {numberWithSpaces(savelendSum)}
              <br />
            </p>
            <p>
              Sum for Borrower: {numberWithSpaces(borrowerSum)}
              <br />
            </p>
          </div>
        ) : undefined}
        {!this.props.loansForPayout.fetched ? (
          <div> Loading... </div>
        ) : (
          <TableNew
            {...this.props}
            columns={this.state.payoutColumns}
            tableKey={"Payouts"}
            selectId={"Id"}
            items={itemsCombined}
            actionColumnWidth={200}
            aboveContentRenderer={(getSelected, rows, props) => {
              return (
                <PayoutTableButtons
                  {...props}
                  getSelected={getSelected}
                  rows={rows}
                />
              );
            }}
          />
        )}
      </div>
    );
  }

  static propTypes = {
    loansForPayout: PropTypes.any,
    investmentInfo: PropTypes.any,
    accountInfo: PropTypes.object,
    payout: PropTypes.object,
    isMpl: PropTypes.bool,

    changeFinancingIssuedListPage: PropTypes.func,
    changeFinancingIssuedListFilter: PropTypes.func,
    getFinancingBookingAccountInfo: PropTypes.func,
    getIssuedFinancings: PropTypes.func,
    getFinancingPayoutInfo: PropTypes.func,
    cancelLoan: PropTypes.func,
    registerPayout: PropTypes.func,
    pushErrorNotification: PropTypes.func,
  };
}
export const Payouts = compose(payoutConnector)(PayoutComponent);
export const MPLPayout = compose(mplPayoutConnector)(PayoutComponent);
